import qs from 'qs';

const getInitialValuesFromQuery = (query, defaults = {}) => {
    const params = qs.parse(query, {
        ignoreQueryPrefix: true,
        decodeURIComponent: true
    });

  if (params.username) {
        params.username = params.username.replace(/ /g, '+');
    }

    return {
        ...defaults,
        ...params,
    };
};

export default getInitialValuesFromQuery;